import { createContext } from 'react';
import {
    QUERY_KEYS_SECURITY,
    useChartsData
} from '../../../../Common/hooks/useChartsData';
import { useSecurityFiltersContext } from '../../../Common/Filters/hooks/useSecurityFiltersContext';

export const CrimesChartsDataContext = createContext();

const CrimesChartsDataProvider = ({ children }) => {
    const { filters } = useSecurityFiltersContext();
    const filterParams = {
            year: filters.year?.value || '',
            month: filters.month?.value ? String(parseInt(filters.month.value)) : '',
            location: filters.unidade.value,
            city: filters.cidade?.value,
    }

    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_SECURITY.CRIMES_RUBRIC_EVOLUTION,
            url: 'governanceroom/securitydashboard/criminalData/crimes/rubricEvolution'
        },
        filterParams
    );

    const conductEvolutionData = useChartsData(
        {
            key: QUERY_KEYS_SECURITY.CRIMES_CONDUCT_EVOLUTION,
            url: 'governanceroom/securitydashboard/criminalData/crimes/conductEvolution'
        },
        filterParams
    );

    const determinedNatureEvolutionData = useChartsData(
        {
            key: QUERY_KEYS_SECURITY.CRIMES_DETERMINED_NATURE_EVOLUTION,
            url: 'governanceroom/securitydashboard/criminalData/crimes/determinedNatureEvolution'
        },
        filterParams
    );

    const chartData = {
        rubricEvolutionAnual: data?.anualEvolution || [],
        rubricEvolutionMonth: data?.monthEvolution || [],
        conductEvolutionAnual: conductEvolutionData.data?.anualEvolution || [],
        conductEvolutionMonth: conductEvolutionData.data?.monthEvolution || [],
        determinedNatureEvolutionAnual: determinedNatureEvolutionData.data?.anualEvolution || [],
        determinedNatureEvolutionMonth: determinedNatureEvolutionData.data?.monthEvolution || []
    }

    return (
        <CrimesChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </CrimesChartsDataContext.Provider>
    );
};

export default CrimesChartsDataProvider;
